import NotificationEmails from "pages/MyData/NotificationEmails"
import React from "react"
import { useEffect } from "react"

const NotificationsDrawer = ({ isOpen, toggleModal }) => {
  useEffect(() => {
    if (isOpen) {
      loadData()
    }
  }, [isOpen])

  const loadData = async () => {}

  if (!isOpen) {
    return null
  }
  return (
    <div
      style={{
        position: "absolute",
        top: "70px",
        right: 0,
        height: "calc(100vh - 120px)",
        zIndex: 1000,
        width: "600px",
        backgroundColor: "white",
        padding: "20px",
        borderLeft: "3px solid lightgray",
        borderTop: "3px solid lightgray",
        borderBottom: "3px solid lightgray",
      }}
    >
      <div className="mb-3" style={{ width: "100%" }}>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          style={{ float: "right" }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div style={{height: '100%', overflowY: 'auto', overflowX: 'hidden'}}>
        <NotificationEmails />
      </div>
    </div>
  )
}

export default NotificationsDrawer
